import { browserHistory } from 'common/utils/browserHistory';

export default function goToOpenCasesIndex() {
  browserHistory.push('/dashboard/cases/open');
}
